<template>
  <section class="subscription-section bg-grey">
    <div class="container">

      <div class="main-heading text-center mb-5">
        <h1 class="title-section">Historial de suscripción</h1>
        <p class="subtitle">Manage and review your plans</p>
      </div>

      <!-- Loading -->
      <div v-if="loading" class="text-center text-white">
        Loading...
      </div>

      <!-- Empty -->
      <div v-if="!loading && history.length === 0" class="empty-state">
        No subscription history found.
      </div>

      <!-- History Cards -->
      <div v-if="history.length" class="history-wrapper">

        <div 
          class="history-card"
          v-for="item in sortedHistory"
          :key="item.id"
          :class="{ activeCard: item.status === 'active' }"
        >

          <!-- Top Section -->
          <div class="history-top">
            <div>
              <h3 class="plan-title">{{ item.plan_name }}</h3>
              <p class="plan-price">
                ${{ item.price }} / {{ item.interval }}
              </p>
            </div>

            <div v-if="item.status === 'active'" class="active-actions">
                    <div class="status-badge active">
                        ACTIVO
                    </div>

                    <button class="cancel-btn" @click="cancelSubscription(item.id)">
                        Cancelar
                    </button>
                    </div>

                    <div v-else class="status-badge" :class="item.status">
                    {{ item.status.toUpperCase() }}
                    </div>
            </div>

          <!-- Divider -->
          <div class="divider"></div>

          <!-- Details Grid -->
          <div class="history-grid">

            <div class="grid-item">
              <span>ID de suscripción</span>
              <strong>{{ item.paypal_subscription_id }}</strong>
            </div>

            <div class="grid-item">
              <span>Fecha de inicio</span>
              <strong>{{ formatDate(item.start_date) }}</strong>
            </div>

            <div class="grid-item">
              <span>Fecha de finalización</span>
              <strong>{{ formatDate(item.end_date) }}</strong>
            </div>

            

          </div>

        </div>

      </div>

    </div>
  </section>
</template>

<script>
import { HTTP } from '../../_helper/http-constants.js';

export default {
  name: 'SubscriptionHistory',

  data() {
    return {
      history: [],
      loading: false
    }
  },

  computed: {
    sortedHistory() {
      return [...this.history].sort((a, b) => {
        if (a.status === 'active') return -1;
        if (b.status === 'active') return 1;
        return new Date(b.created_at) - new Date(a.created_at);
      });
    }
  },

  methods: {

    async fetchHistory() {
      try {
        this.loading = true;

        const res = await HTTP.get('/subscription/history');

        if (res.data.status) {
          this.history = res.data.data;
        }

        this.loading = false;

      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },
    async cancelSubscription(id) {

        if (!confirm("¿Estás segura de que deseas cancelar tu suscripción?")) {
            return;
        }

        try {

            const res = await HTTP.post('/subscription/cancel', {
            subscription_id: id
            });

            if (res.data.status) {
            alert("Suscripción cancelada con éxito.");
            this.fetchHistory();
            }

        } catch (e) {
            console.error(e);
            alert("No se pudo cancelar la suscripción.");
        }
    },

    formatDate(date) {
      if (!date) return '-';
      return new Date(date).toLocaleDateString() + " " + 
             new Date(date).toLocaleTimeString();
    }

  },

  mounted() {
    this.fetchHistory();
  }
}
</script>

<style scoped>

.subtitle {
  color: #888;
  font-size: 14px;
}

.history-wrapper {
  max-width: 900px;
  margin: auto;
}

.history-card {
  background: linear-gradient(145deg, #111, #0d0d0d);
  border-radius: 18px;
  padding: 30px;
  margin-bottom: 30px;
  border: 1px solid #1f1f1f;
  transition: all 0.3s ease;
  color: #fff;
}

.history-card:hover {
  transform: translateY(-6px);
  border-color: #00c6ff;
}

.activeCard {
  border: 1px solid #00c6ff;
  box-shadow: 0 0 30px rgba(0, 198, 255, 0.3);
}

.history-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.plan-title {
  margin: 0;
  font-size: 22px;
}

.plan-price {
  color: #00c6ff;
  margin: 5px 0 0 0;
  font-weight: 500;
}

.divider {
  height: 1px;
  background: #222;
  margin: 20px 0;
}

.history-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.grid-item span {
  display: block;
  font-size: 12px;
  color: #888;
  margin-bottom: 5px;
}

.grid-item strong {
  font-size: 14px;
}

.status-badge {
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
}

.status-badge.active {
  background: linear-gradient(45deg, #00c6ff, #0072ff);
  color: #000;
}

.status-badge.cancelled {
  background: #ff4d4d;
}

.status-badge.expired {
  background: #555;
}

.status-badge.suspended {
  background: orange;
  color: #000;
}

.empty-state {
  text-align: center;
  color: #777;
  padding: 40px;
}
.active-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.cancel-btn {
  background: transparent;
  border: 1px solid #ff4d4d;
  color: #ff4d4d;
  padding: 6px 14px;
  border-radius: 50px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: #ff4d4d;
  color: #fff;
}

</style>